<template>
	<div id="main">
		<div class="banner">
			<div class="fafa flexslider">
				<ul class="slides">
					<li v-for="(item,index) in bannerList" :key="index" 
					:style="{ backgroundImage: 'url('+icoURL+'storage/'+item.image+')'}"
					>
						<div class="container" :class="{lan:item.title == '测绘工程' , mx440:item.title == '地质灾害防治'}">
							<h1>{{item.title}}</h1>
							<h2>{{item.excerpt}}</h2>
							<div class="banner_a" @click="bannerTo(item)">查看更多</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="main">
			<div class="main1 pp50">
				<div class="container">
					<div class="main1-1 fl">
						<div class="fmain1 flexslider">
							<ul class="slides">
								<li v-for="(item,index) in recommendList" :key="index" >
									<div class="main1-1_a imgbox_a" @click="toDetal(item)"
									:style="{ backgroundImage: 'url('+icoURL+'storage/'+item.image+')'}"
									>
										<!-- <img :src="icoURL+'storage/'+item.image" alt=""> -->
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="main1-2">
						<div class="title-11">
							<h1 class="fl">公司动态</h1>
							<div class="clear"></div>
						</div>
						<div class="list01">
							<!-- {{newsList}} -->
							<dl>
								<dd v-for="(item,index) in newsList" :key="index">
									<div class="list01_a" @click="toDetal(item)">{{item.title}}</div>
									<span class="span_11">{{item.created_at.slice(0,10)}}</span>
								</dd>
							</dl>
						</div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="main2 pp50">
				<div class="container">
					<div class="title-11 text-center">
						<h1>资质展示</h1>
					</div>
					<div class="main2-div mm40">
						<div class="main2-list">
							<div class="main2-item" v-for="(item,index) in aptitudeList" :key="index">
								<div class="main2-pic">
									<div class="imgbox_a"><img :src="icoURL+'storage/'+item.image" alt=""></div>
								</div>
								<div class="main2-h1 tver">{{item.title}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="main3 pp50">
				<div class="container">
					<div class="main3-1 fl">
						<div class="title-22">
							<h1>关于我们</h1>
						</div>
						<div class="main3-1-div">
							<div class="main3-1-pic fl">
								<div class="imgbox_a"><img :src="icoURL+'storage/'+this.aboutus.image" alt=""></div>
							</div>
							<div class="main3-1-con">
								<div class="main3-1-p">
									{{this.aboutus.excerpt}}
								</div>
								<div class="more11" @click="aboutTo()">查看更多</div>
							</div>
							<div class="clear"></div>
						</div>
					</div>
					<div class="main3-2 fr">
						<div class="main3-2-item" v-for="(item,index) in zlList" :key="index" @click="zlTo(item)">
							<div class="imgbox_a imgbox_hover">
								<img :src="icoURL+'storage/'+item.image" alt="">
							</div>
						</div>
						<div class="clear"></div>
					</div>
					<div class="clear"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/js/jquery.flexslider.js';
	import '../assets/js/jquery.liMarquee.js';
	export default{
		name:'home',
		data(){
				return{
					recommendList:[],
					recommendId:'1410',
					newsList:[],
					bannerList:[],
					aptitudeList:[],
					aboutus:{},
					zlList:[]
					
				}
		},
		methods:{
			//请求banner
			res_banner(){
				this.axios.get("/api/banner")
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.bannerList = response.data.reslut;
							this.$nextTick(() => {
								$(".fafa").flexslider({
									animation : "slide",
									slideshowSpeed: 4000, //展示时间间隔ms
									animationSpeed:500, //滚动时间ms
									slideshow: true,// 载入页面时，是否自动播放
									controlNav: true,  //指示器
									directionNav: true //方向键
								});	
							})
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			bannerTo(e){
				console.log(e)
				if(e.title == "地质勘查"){
					this.$router.push({
						path:'/slider/1412/single',
						query:{
							category_id:1413
						}
					})
				}else if(e.title == "测绘工程"){
					this.$router.push({
						path:'/slider/1412/single',
						query:{
							category_id:1422
						}
					})
				}else if(e.title == "地质灾害防治"){
					this.$router.push({
						path:'/slider/1412/single',
						query:{
							category_id:1423
						}
					})
				}else{
					this.$router.push({
						path:'/slider/1412/single',
						query:{
							category_id:1424
						}
					})
				}
			},
			//请求推荐新闻
			res_recommend(){
				this.axios.get("/api/news/featureNews?category_id="+this.recommendId+"&number=4")
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.recommendList = response.data.reslut;
							this.$nextTick(() => {
								$(".fmain1").flexslider({
									animation : "fade",
									slideshowSpeed: 4000, //展示时间间隔ms
									animationSpeed:500, //滚动时间ms
									slideshow: true,// 载入页面时，是否自动播放
									controlNav: true,  //指示器
									directionNav: false //方向键
								});
							})
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//跳转详情页
			toDetal(item){
				console.log(item)
				$('html, body').animate({ scrollTop: 0 }, 0);
				this.$router.push({
					path:'/detail/'+item.parent_id,
					query:{
						category_id:item.category_id,
						id:item.id
					}
				})
			},
			//请求公司动态
			res_news(){
				this.axios.get("/api/news/listNews?category_id="+this.recommendId+"&limit=7")
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.newsList = response.data.reslut.data;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求资质展示
			res_aptitude(){
				this.axios.get("/api/news/listNews?category_id=1420")
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.aptitudeList = response.data.reslut;
							this.$nextTick(() => {
								$(".main2-list").liMarquee({
									drag: false,
									scrollamount: 100,
									direction: 'left',
									runshort: false
								});
							})
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求首页关于我们
			res_about(){
				this.axios.get("/api/single?category_id=1417")
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.aboutus = response.data.reslut;
							// this.aboutus.aboutcon = response.data.reslut.excerpt;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			aboutTo(){
				$('html, body').animate({ scrollTop: 0 }, 0);
				this.$router.push({
					path:'/slider/'+this.aboutus.parent_id+'/single',
					query:{
						category_id:this.aboutus.category_id
					}
				})
			},
			//请求专栏信息
			res_zl(){
				this.axios.get("/api/menus/parentNumber?id=1435")
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.zlList = response.data.reslut
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			zlTo(e){
				console.log('ee',e)
				// console.log('跳转专栏')
				$('html, body').animate({ scrollTop: 0 }, 0);
				this.$router.push({
					path:'/column',
					query:{
						id:e.id,
						name:e.name
					}
				})
			}
		},
		created(){
			this.res_recommend();
			this.res_news();
			this.res_banner();
			this.res_aptitude();
			this.res_about();
			this.res_zl();
		},
		mounted(){
			
			
		}
	}
</script>

<style>
</style>